module.exports = "/images/loading.gif?12014b482243a7d04fd94c90513f0496";